import { useIntl } from 'react-intl';
import {
  AlogEvent,
  TableCells,
  TableColumn,
  auditLogFactory,
} from '@eas/common-web';

export function useColumns(): TableColumn<AlogEvent>[] {
  const intl = useIntl();

  const columns = auditLogFactory
    .useColumns()
    .filter((column) => column.datakey !== 'message');

  return [
    {
      datakey: 'message',
      name: intl.formatMessage({
        id: 'EAS_ALOG_COLUMN_MESSAGE',
        defaultMessage: 'Zpráva',
      }),
      width: 300,
      CellComponent: TableCells.TextCell,
      sortable: false,
      filterable: true,
    },
    ...columns,
  ];
}
